// 하버사인 공식을 사용하여 두 지점 간의 거리를 미터 단위로 계산
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371000; // 지구의 반지름 (미터)
    const p1 = lat1 * Math.PI / 180; // φ, λ를 라디안으로 변환
    const p2 = lat2 * Math.PI / 180;
    const dp = (lat2 - lat1) * Math.PI / 180;
    const dλ = (lon2 - lon1) * Math.PI / 180;

    const a = Math.sin(dp/2) * Math.sin(dp/2) +
              Math.cos(p1) * Math.cos(p2) *
              Math.sin(dλ/2) * Math.sin(dλ/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

    const distance = R * c; // 미터 단위

    return distance;
};
